export default __webpack_public_path__ + "static/media/studentRealCase1-mobile.234f8c9d.png";